import { Expose } from "class-transformer";
import { PgaPolicyDetail } from "./policy-detail.model";

export class VehiclePolicyDetail extends PgaPolicyDetail {
    @Expose() category = "";
    @Expose() broker = -1;
    @Expose() drivenCity: string | null = null;
    // purchaseChannel skipped for now
}
